/* eslint-disable import/prefer-default-export */
export const EQUIPMENT_TYPES = {
  parachute: 'parachute',
  harness: 'harness',
};
